<template>
  <div>
    <v-dialog
      v-model="_active"
      @click:outside="_setActive(false)"
      width="500px"
    >
      <v-card class="px-4 pt-4 pb-6">
        <v-card-title>
          <v-card-text class="text-center text-subtitle-1 pt-0">
            {{
              `Are you sure you want to to delete this ${
                _client.client_name === "shark" ? "golf car" : "screen"
              }?`
            }}
          </v-card-text>
        </v-card-title>
        <div class="d-flex justify-space-around">
          <v-btn
            class="white--text"
            color="primary"
            width="100px"
            @click="_setActive(false)"
            >Cancel</v-btn
          >
          <v-btn
            class="white--text"
            color="red"
            width="100px"
            @click="deleteScreen()"
            >Delete</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ScreenDetailData from '@/mixins/ScreenDetailData';

export default {
  mixins: [ScreenDetailData],
  computed: {
    ...mapGetters({
      _active: 'screenDetails/getDeleteModal',
      _client: 'account/getCurrentClient',
    }),
  },
  methods: {
    ...mapMutations({
      _setActive: 'screenDetails/setDeleteModal',
    }),
    ...mapActions({
      _deleteScreen: 'screenDetails/deleteScreen',
    }),
    deleteScreen() {
      this._setActive(false);
      this._deleteScreen(this.data.uuid);
      this.$router.push(`/${this._client.client_name.toLowerCase()}/screens`);
    },
  },
};
</script>
